import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import BackButton from '@/components/BackButton/BackButton';
import DynamicPage from '@/components/DynamicPage/DynamicPage';
import PAGE_IDS from '@/consts/pageIds';
import useMenuVisibility from '@/hooks/useMenuVisibility';
import appRouterService from '@/services/route/appRouterService';
import {selectInProgressBadges} from '@/state/selectors/loyalty';

const InProgressPage = () => {
    const {hideMenu} = useMenuVisibility();
    const inProgressBadges = useSelector(selectInProgressBadges);

    useEffect(() => {
        hideMenu();
    }, [hideMenu]);

    // If a refetch (e.g. after returning from an external link) leaves no
    // in-progress badges, this page has nothing meaningful to show — go back.
    useEffect(() => {
        if (inProgressBadges.length === 0) {
            appRouterService.goBack();
        }
    }, [inProgressBadges.length]);

    return (
        <div className='flex h-auto flex-col'>
            <BackButton onClick={appRouterService.goBack} className='mt-app-4 ml-4 shrink-0' />
            <DynamicPage pageId={PAGE_IDS.IN_PROGRESS} className='min-h-0 flex-1 pb-app-4' />
        </div>
    );
};

export default InProgressPage;
